<template>
  <div class="register absolute">
    <div class="register_tit">
      <img @click="$router.go(-1)" src="../../assets/images/licai/fanhui.png" />
      <p class="">{{ $t("m.rg_span0") }}</p>
    </div>

    <div class="register_block" style="padding:10px;">
      <div style="height: 120px;overflow: hidden;border-radius:6px;">
        <img
          style="width: 100%;border-radius:6px;"
          src="../../assets/images/new/rengou.png"
          alt=""
        />
      </div>

      <div
        style="border-radius:6px; height:70px;width: 100%; margin-top:10px;background-color:#fff;display:flex;align-items:center;justify-content: space-between;padding:0 10px;"
      >
        <span style="font-size:16px;"
          >{{ dicdata.tag }}{{ dicdata.title }}</span
        >
        <div>
          <p style="color: var(--bg-color);font-size:14px;">
            <span style="font-size:24px;">{{ dicdata.rate }}</span
            >%
          </p>
          <!-- <p style="font-size:12px;color:#999;">日回报率</p> -->
        </div>
      </div>

      <div
        style="border-radius:6px;width: 100%; margin-top:10px;background-color:#fff;padding:15px 10px;padding-bottom:0;"
      >
        <!-- <span style="font-size:16px;">{{$t('m.tz_span4')}}</span> -->
        <div
          style="display:flex;align-items:center; font-size:26px;font-weight:bold;padding-left:10px;margin-top:0px;line-height:50px;"
        >
          <span style="font-size:15px;width: 50px;">金额</span>
          <input
            readonly="readonly"
            style="margin-left:0px;border-bottom:1px solid #eee;"
            @click="show = true"
            v-model="money"
            autocomplete="off"
          />
        </div>
      </div>
      <div
        style="border-radius:6px; width: 100%; margin-top:10px;background-color:#fff;padding:0px 10px;padding-bottom:0;"
      >
        <!-- <span style="font-size:16px;"></span> -->
        <div
          style="font-size:14px;margin-top:10px;line-height:70px;display:flex;align-items:center;"
        >
          {{ $t("m.yh_span7") }}
          <input
            style=" margin-left:20px;border-bottom:1px solid #eee; line-height:50px;height:50px;flex:1;"
            v-model="mima"
          />
        </div>
      </div>
      <div
        v-if="dangqian == 0"
        style="border-radius:6px; height:50px;width: 100%; margin-top:10px;background-color:#fff;display:flex;align-items:center;justify-content: space-between;padding:0 10px;"
      >
        <span style="font-size:16px;flex:1;">{{ $t("m.yue") }}</span>
        <div style="width: 170px;">
          <p style="font-size:14px;text-align:right;padding-right:10px;">
            {{ ktxje }}
          </p>
        </div>
        <img
          src="../../assets/images/licai/right.png"
          style="width: 20px;height: 20px;margin-left:0px;"
          alt=""
        />
      </div>
      <div
        v-else-if="dangqian == 2"
        style="border-radius:6px; height:50px;width: 100%; margin-top:10px;background-color:#fff;display:flex;align-items:center;justify-content: space-between;padding:0 10px;"
      >
        <span style="font-size:16px;flex:1;">GMO余额</span>
        <div style="width: 170px;">
          <p style="font-size:14px;text-align:right;padding-right:10px;">
            {{ ktxje2 }}
          </p>
        </div>
        <img
          src="../../assets/images/licai/right.png"
          style="width: 20px;height: 20px;margin-left:0px;"
          alt=""
        />
      </div>
      <div
        v-else
        style="border-radius:6px; height:50px;width: 100%; margin-top:10px;background-color:#fff;display:flex;align-items:center;justify-content: space-between;padding:0 10px;"
      >
        <span style="font-size:16px;flex:1;">USDT</span>
        <div style="width: 170px;">
          <p style="font-size:14px;text-align:right;padding-right:10px;">
            {{ ktxje1 }}
          </p>
        </div>
        <img
          src="../../assets/images/licai/right.png"
          style="width: 20px;height: 20px;margin-left:0px;"
          alt=""
        />
      </div>
      <van-button
        class="register_submit"
        type="info"
        @click="registerReset(dicdata.id)"
        >{{ $t("m.tijiao") }}</van-button
      >
      <div
        style="padding-left:10px; height:50px;border-top:0px solid #eee;height:50px;font-size:13px;color:#666;margin-top:10px;"
      >
        {{ $t("m.rg_span1")
        }}<span style="color:var(--bg-color);">{{ qi }}</span
        >{{ $t("m.rg_span11")
        }}<span style="color:var(--bg-color);">{{ gao }}</span
        >{{ $t("m.rg_span12")
        }}<span style="color:var(--bg-color);">{{ dicdata.mcount }}</span>
        {{ $t("m.rg_span2")
        }}<span style="color:var(--bg-color);">{{ huilv }}</span>
      </div>
    </div>

    <div style="height: 100px;width: 100%;"></div>
    <!-- <div style="width: 92%;
  margin: 20px auto;color: #666;font-size:12px;display:flex;align-items:center;" >
        <img style="width: 14px;height: 14px;margin-right:4px;" src="../../assets/images/licai/shangcheng.png" alt="">
        通过注册，代表你同意我们的使用条款和条件
    </div> -->
    <van-number-keyboard
      :show="show"
      theme="custom"
      extra-key="."
      :close-button-text="$t('m.finish')"
      @blur="show = false"
      @input="onInput"
      @delete="onDelete"
    />
    <div
      v-if="shows"
      style="background: rgba(0, 0, 0, 0.5);position: fixed;width: 100%;height: 100%;left:0;top:0;display: flex;align-items: center;justify-content: center;"
    >
      <div
        style="background: rgba(0, 0, 0, 0.7);width:130px;height:130px;border-radius:8px;text-align:center;line-height:130px;color:#fff;font-size:16px;"
      >
        {{ $t("m.tijiaoing") }}
      </div>
    </div>
  </div>
</template>

<script>
import request from "@utils/request";
import { getMyUserInfo } from "../../api/user";
export default {
  name: "GoodsPay",
  data: function() {
    return {
      shows: false,
      show: false,
      money: "",
      qi: 0,
      gao: 0,
      mima: "",
      dicdata: {},
      dangqian: 0,
      ktxje: 0,
      huilv: 1,
      ktxje1: 0,
      ktxje2: 0
    };
  },

  mounted: function() {
    this.dangqian = localStorage.getItem("zhonglei");
    getMyUserInfo().then(res => {
      console.log(res.data, res.data.data.money);
      this.ktxje = res.data.data.money;
      this.ktxje1 = res.data.data.usdt;
      this.ktxje2 = res.data.data.gmo || "0.00";
      if (res.data.data.is_auth != 1) {
        this.$dialog.message("请先完成实名认证");
        this.$router.push({ name: "memmber_business" });
      }
    });
    let type = this.$route.params.id;
    console.log("传参");
    console.log(type);
    // this.$nextTick(function() {
    request
      .get("/fund/project/detail", { id: type }, { login: false })
      .then(res => {
        console.log(res.data.data);
        this.dicdata = res.data.data;
        this.money = this.dicdata.min + "";
        this.qi = this.dicdata.min + "";
        this.gao = this.dicdata.max + "";
        request
          .post("/pay/us/cache", {}, { login: true })
          .then(qres => {
            let userInfo = qres.data.data;
            this.huilv = (userInfo.usd_cny * userInfo.usdt_usdk).toFixed(2);
            console.log("汇率");
            console.log(this.huilv);
            console.log(this.dangqian);
            if (this.dangqian == 1) {
              const minUsdt =
                this.dicdata.min_usdt ||
                Math.ceil(this.dicdata.min / parseFloat(this.huilv));
              const maxUsdt =
                this.dicdata.max_usdt ||
                Math.ceil(this.dicdata.max / parseFloat(this.huilv));
              this.qi = minUsdt;
              this.gao = maxUsdt;
              this.money = String(minUsdt);
            }
          })
          .catch(err => {
            this.$dialog.error(err.response.data.msg);
          });
      })
      .catch(err => {
        this.$dialog.error(err.response.data.msg);
      });
    // });
  },
  methods: {
    onInput(value) {
      let vm = this;
      this.money = vm.money + value;
    },
    onDelete() {
      console.log("sdsdsa");
      this.money = this.money.slice(0, this.money.length - 1);
    },
    registerReset(e) {
      if (this.money.length <= 0) {
        this.$dialog.message("请输入购买金额");
        return;
      }
      // if (this.money<this.dicdata.min) {
      //      this.$dialog.message("购买金额最低"+this.dicdata.min+"元");
      //      return;
      // }
      if (this.mima.length <= 0) {
        this.$dialog.message("请输入密码");
        return;
      }
      this.shows = true;
      localStorage.setItem(
        "shu",
        JSON.stringify({ money: this.money, name: this.dicdata.title })
      );
      let url = "/fund/add";
      if (this.dangqian == 1) {
        url = "/fund/usdt/add";
      } else if (this.dangqian == 2) {
        url = "/fund/gmo/add";
      }
      request
        .post(
          url,
          { id: e, pwd: this.mima, money: this.money },
          { login: true }
        )
        .then(res => {
          this.shows = false;
          console.log(res.data.data);
          this.$router.push({
            path: "/finish"
          });
        })
        .catch(err => {
          this.shows = false;
          this.$dialog.error(err.response.data.msg);
        });
    }
  }
};
</script>
<style scoped>
.register_submit {
  width: 100%;
  margin: 0 auto;
  height: 45px;
  background: var(--bg-color);
  border-radius: 30px;
  margin-top: 40px;
  text-align: center;
  line-height: 45px;
  color: #ffffff;
  border: 0px solid;
  font-size: 15px;
  font-weight: bold;
}

.register_block {
  padding: 0;
}
.register_block_list {
  width: 100%;
  height: 50px;
  padding: 0 15px;
  background: #f1f1f3;
  border-radius: 5px;
  display: flex;
  align-items: center;
  font-size: 14px;
  margin-top: 15px;
}
.register_code_lists {
  border: 1px solid #007aff;
  text-align: center;
  color: #007aff;
  border-radius: 6px;
  width: 36%;
  height: 45px;
  margin-left: 15px;
  line-height: 45px;
}
.register_code_list {
  width: 100%;
  height: 50px;
  padding: 0 15px;
  background: #f1f1f3;
  border-radius: 5px;
  display: flex;
  align-items: center;
  font-size: 14px;
}
.register_code {
  display: flex;
  align-items: center;
  margin-top: 15px;
}
.register_tit {
  background: #fff;
  display: flex;
  align-items: center;
  position: relative;
  justify-content: center;
  padding: 5px;
}
.register_tit img {
  width: 30px;
  height: 30px;
  position: absolute;
  left: 15px;
}
.register_tit p {
  text-align: center;
  text-align: center;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
  line-height: 35px;
}
/* 清除浮动*/
.am-fl {
  float: left;
}
.am-fr {
  float: right;
}
.am-cf:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.am-cf {
  zoom: 1;
}
</style>
